import { DefaultState } from 'store/types';

export const CLONE_LODGING_REQUEST_REQUEST = 'CLONE_LODGING_REQUEST_REQUEST';
export const CLONE_LODGING_REQUEST_SUCCESS = 'CLONE_LODGING_REQUEST_SUCCESS';
export const CLONE_LODGING_REQUEST_FAILURE = 'CLONE_LODGING_REQUEST_FAILURE';

export type CloneLodgingRequestState = DefaultState;

export interface CloneLodgingRequestDatesData {
  lodgingRequestsIds: string[];
  fromDate: string;
  toDate: string;
  locationId: string;
  talentAgentEmail: string;
};

interface CloneLodgingRequestRequest {
  type: typeof CLONE_LODGING_REQUEST_REQUEST;
}

interface CloneLodgingRequestSuccess {
  type: typeof CLONE_LODGING_REQUEST_SUCCESS;
}

interface CloneLodgingRequestFailure {
  type: typeof CLONE_LODGING_REQUEST_FAILURE;
}

export type CloneLodgingRequestActionTypes =
  | CloneLodgingRequestRequest
  | CloneLodgingRequestSuccess
  | CloneLodgingRequestFailure;
